import { ObjectsEnum } from "./enums/basket";
import financeIcon from '../images/icons/structure-object/finance-icon.svg';
import { panelItems } from "./data/panel-items";

export default function pluralizeElements(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return "елемент";
  } else if (
    mod10 >= 2 &&
    mod10 <= 4 &&
    !(mod100 >= 12 && mod100 <= 14)
  ) {
    return "елементи";
  } else {
    return "елементів";
  }
}


export const getItemsCountTable = (arr: any[]) => (arr.length > 5 ? 5 : arr.length);

export function toCamelCase(value: string): string {
  return value
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((word, index) =>
      index === 0
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join('');
}

export const getStructureItem = (key: string) => {
  const lowerKey = key.toLowerCase();

  if (lowerKey === ObjectsEnum.EXPENSE) {
    return {
      id: key,
      name: "Витрати",
      icon: financeIcon,
    };
  }

  if (lowerKey === ObjectsEnum.INCOME) {
    return {
      id: key,
      name: "Надходження",
      icon: financeIcon,
    };
  }

  const panelItem = panelItems.find(x => x.id === lowerKey);

  return {
    id: key,
    name: panelItem?.name ?? key,
    icon: panelItem?.icons[1],
  };
};
